import {
  PROJECTED_TILE_SIZE,
  TILE_PROJECTION_MULTIPLIERS,
  UNPROJECTED_TILE_SIZE
} from 'src/config/grid';
import { IsometricGrid } from './IsometricGrid ';

/**
 * Shared projection used by rendering, hit testing and the grid background.
 * Keeping one configured instance prevents the formulas from drifting apart.
 */
export const defaultIsometricGrid = new IsometricGrid({
  unprojectedTileSize: UNPROJECTED_TILE_SIZE,
  projectionMultipliers: TILE_PROJECTION_MULTIPLIERS,
  projectedTileSize: PROJECTED_TILE_SIZE
});
